import { render } from "./SteamWastedHours.vue?vue&type=template&id=4771f75e"
import script from "./SteamWastedHours.vue?vue&type=script&lang=js"
export * from "./SteamWastedHours.vue?vue&type=script&lang=js"

import "../styles/seo-page.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__